<template>
  <v-app>
    <Header :menuRouter="menuRouter" />
    <v-main>
      <v-row style="height: 100%">
        <v-navigation-drawer hide-overlay app permanent clipped>
          <Sidebar class="mt-3" :items="menuRouter" />
        </v-navigation-drawer>
        <v-col>
          <main-View>
            <router-view :key="$route.fullPath"/>
          </main-View>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import MainView from "./MainView";
import Sidebar from "./Sidebar";
import Header from "./Header";
export default {
  name: "BasicLayout",
  props: {
    source: String
  },
  components: {
    MainView,
    Sidebar,
    Header
  },
  data: () => ({
    drawer: true,
    menuRouter: []
  }),
   watch:{
    "$route": function(val){
      console.log("val: ",val)
    }
  },
  beforeUpdate(){
    console.log("____________")
  },
  created() {
    this.menuRouter = this.$router.options.routes.filter(
      item => item.path !== "/"
    );
  }
};
</script>
<style lang="scss" scoped>
.toolbar-title {
  font-size: 1.8rem;
}
.v-list-item__content > * {
  line-height: 1.3;
  width: 3.9rem;
}
</style>
